
import Vue from "vue";
import { SaleEditRowExtraInfoField } from "@/utils/sale-edit/sale-edit-row-extra-info-field";
import { TranslateResult } from "vue-i18n";
import AppColumnSelect from "@/components/models/ColumnSelect.vue";
import { Model, getModel } from "@/utils/models/model";

export default Vue.extend({
	data(){
		return {
			settings: new SaleEditRowExtraInfoField()
		};
	},
	props: {
		value: {
			type: Object as ()=>SaleEditRowExtraInfoField,
			required: true
		},
		isNew: Boolean
	},
	computed: {
		title():TranslateResult{
			if (this.isNew){
				return this.$ct("edit-row");
			}
			return this.$ct("add-row");
		},
		model():Model{
			return getModel("Product");
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(){
				this.settings = new SaleEditRowExtraInfoField(this.value.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.$emit("input", this.settings);
			this.close();
		}
	},
	components: {
		AppColumnSelect
	},
	i18nEx: {
		componentPrefix: "components.sale-settings"
	}
});
